import { Col, Pagination, Row } from 'antd'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import React from 'react'

import ApartmentIcon from 'components/icons/ApartmentIcon'
import Noevent from 'components/icons/noevent.svg'
import {
  Address,
  ContentCenterDiv,
  FullTable,
  LeftAlignCol,
  Name,
  Name1,
  NameAdd,
  SlCol,
  SlCol1,
  SlRow,
} from 'modules/Drives/Style/style'
import moment from 'moment'
import { useNavigate } from 'react-router-dom'

const SingleListed = ({
  drivesList,
  onPageChange,
  occurrence,
  studentDetails,
  page,
}) => {
  const navigate = useNavigate()

  const driveDetails = (event, param) => {
    navigate(`/driveDetails/${param?.roleId}/${param?.driveId}`)
  }

  const checkDate = (start, end) => {
    let startDate = moment(start)
    let endDate = moment(end)

    return startDate?.format('DD/MM/YYYY') + ' - ' + endDate?.format('DD/MM/YYYY')
  }
  const getDriveMode = driveMode => {
    return driveMode?.toLowerCase().replace('_', ' ')
  }

  const checkTime = (start, end) => {
    let startTime = `${Number(start?.slice(0, 2)) > 12 ? 'PM' : 'AM'}`
    let endTime = `${Number(end?.slice(0, 2)) > 12 ? 'PM' : 'AM'}`
    let startTimeCheck =
      parseInt(start?.slice(0, 2)) > 13
        ? `${parseInt(start?.slice(0, 2)) - 12} ${start?.slice(
            3,
            5
          )} ${startTime}`
        : `${parseInt(start?.slice(0, 2))} ${start?.slice(2, 5)} ${startTime}`
    let endTimeCheck =
      parseInt(end?.slice(0, 2)) > 13
        ? `${parseInt(end?.slice(0, 2)) - 12} ${end?.slice(2, 5)} ${endTime}`
        : `${parseInt(end?.slice(0, 2))} ${end?.slice(2, 5)} ${endTime}`
    return startTimeCheck + ' - ' + endTimeCheck
  }

  const CheckIcon = logo => {
    if (logo === null) {
      return (
        <Avatar
          size={42}
          src={<ApartmentIcon />}
          boxShadow={true}
          padding={'3px'}
        />
      )
    } else {
      return <Avatar size={42} src={logo} />
    }
  }

  const onChange = key => {
    onPageChange(key)
  }
  const CheckDataDate = item => {
    const data = item[item?.length - 1]
    const dateValue = data?.studentInterviewTimeSlotMap?.[0]?.selectedDate
    const formattedDate = moment(dateValue).format('DD/MM/YYYY')
    return formattedDate
  }
  const CheckDataTime = item => {
    const data = item[item?.length - 1]

    return data?.studentInterviewTimeSlotMap?.[0]?.selectedTime &&
      data?.studentInterviewTimeSlotMap?.[0]?.selectedTime != '00:00:00'
      ? data?.studentInterviewTimeSlotMap?.[0]?.selectedTime
      : '-'
  }

  const checkData = item => {
    const data = item?.[item?.length - 1]
    return data?.candidateStatus === 'RESCHEDULE_REQUESTED'
  }

  return (
    <>
      <FullTable>
        {drivesList?.list?.map((item, index) => (
          <SlRow key={index + 'list'}>
            {/* <SlCol1>
                <NameAdd column flexStart>
                  <SingleDate>
                    {checkDate(item?.drive?.startDate, item?.drive?.endDate)}
                  </SingleDate>
                  <Address>
                    &nbsp;
                    {checkMonth(item?.drive.startDate, item?.drive?.endDate)}
                  </Address>
                </NameAdd>
              </SlCol1> */}

            <SlCol1>
              <Row>
                <Col>{CheckIcon(item?.drive?.corporate?.logo)}</Col>
                <LeftAlignCol>
                  <NameAdd column flexStart>
                    <Name1>{item?.drive?.corporate?.name}</Name1>
                    <Address>{item?.role?.tittle}</Address>
                  </NameAdd>
                </LeftAlignCol>
              </Row>
            </SlCol1>

            <SlCol>
              <NameAdd column flexStart>
                <Address>Drive Mode</Address>
                <Name>{getDriveMode(item?.drive?.driveMode)}</Name>
              </NameAdd>
            </SlCol>
            <SlCol>
              <NameAdd column flexStart>
                <Address>Stage</Address>
                <Name>{item?.stage}</Name>
              </NameAdd>
            </SlCol>
            {occurrence != 'REQUESTED' && (
              <>
                <SlCol>
                  <NameAdd column flexStart>
                    <Address>Date & Time </Address>
                    {item?.status === 'SHORTLISTED' ? (
                      '-'
                    ) : checkData(item?.drive?.expCandidateDriveMap) ? (
                      <Name>Requested To Reschedule</Name>
                    ) : (
                      <>
                        {studentDetails?.student?.isExpCandidate ? (
                          <>
                            <Name>
                              {CheckDataDate(item?.studentInterviewMap)}
                            </Name>
                            <Name>
                              {CheckDataTime(item?.studentInterviewMap)}
                            </Name>
                          </>
                        ) : (
                          <>
                            <Name>
                              {checkDate(
                                item?.drive?.startDate,
                                item?.drive?.endDate
                              )}
                            </Name>
                            <Name>
                              {checkTime(
                                item?.drive?.startTime,
                                item?.drive?.endTime
                              )}
                            </Name>
                          </>
                        )}
                      </>
                    )}
                  </NameAdd>
                </SlCol>
                <SlCol>
                  <Button.Secondary
                    onClick={event => driveDetails(event, item)}
                    text={'View'}
                    width={'80px'}
                  />
                </SlCol>
              </>
            )}
            {occurrence === 'REQUESTED' && (
              <SlCol>
                <Button.Secondary
                  onClick={event => driveDetails(event, item)}
                  text={'Pick a date'}
                  width={'100px'}
                />
              </SlCol>
            )}
          </SlRow>
        ))}
      </FullTable>

      {drivesList?.count === 0 ? (
        <ContentCenterDiv>
          <img src={Noevent} alt="NoEvent" />
        </ContentCenterDiv>
      ) : (
        <ContentCenterDiv>
          <br></br>
          <Pagination
            showSizeChanger={false}
            defaultCurrent={0}
            current={page + 1}
            total={drivesList?.count}
            onChange={onChange}
          />
        </ContentCenterDiv>
      )}
    </>
  )
}
export default SingleListed
